/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ErrorInformation } from '../model/errorInformation';
import { Namespace } from '../model/namespace';
import { NamespaceCreateRequest } from '../model/namespaceCreateRequest';
import { NamespaceDefaultRecordFlagUpdateRequest } from '../model/namespaceDefaultRecordFlagUpdateRequest';
import { NamespaceKeys } from '../model/namespaceKeys';
import { NamespaceSearchRequest } from '../model/namespaceSearchRequest';
import { NamespaceSearchResponse } from '../model/namespaceSearchResponse';
import { NamespaceUpdateRequest } from '../model/namespaceUpdateRequest';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class NamespaceService {

    protected basePath = 'http://localhost/herd-app/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * createNamespace
     * Creates a new namespace.
     * @param namespaceCreateRequest the information needed to create the namespace
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public namespaceCreateNamespace(namespaceCreateRequest: NamespaceCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<Namespace>;
    public namespaceCreateNamespace(namespaceCreateRequest: NamespaceCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Namespace>>;
    public namespaceCreateNamespace(namespaceCreateRequest: NamespaceCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Namespace>>;
    public namespaceCreateNamespace(namespaceCreateRequest: NamespaceCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespaceCreateRequest === null || namespaceCreateRequest === undefined) {
            throw new Error('Required parameter namespaceCreateRequest was null or undefined when calling namespaceCreateNamespace.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Namespace>(`${this.configuration.basePath}/namespaces`,
            namespaceCreateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteNamespace
     * Deletes an existing namespace by namespace code.
     * @param namespaceCode the namespace code
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public namespaceDeleteNamespace(namespaceCode: string, observe?: 'body', reportProgress?: boolean): Observable<Namespace>;
    public namespaceDeleteNamespace(namespaceCode: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Namespace>>;
    public namespaceDeleteNamespace(namespaceCode: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Namespace>>;
    public namespaceDeleteNamespace(namespaceCode: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespaceCode === null || namespaceCode === undefined) {
            throw new Error('Required parameter namespaceCode was null or undefined when calling namespaceDeleteNamespace.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<Namespace>(`${this.configuration.basePath}/namespaces/${encodeURIComponent(String(namespaceCode))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getNamespace
     * Gets an existing namespace by namespace code.
     * @param namespaceCode the namespace code
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public namespaceGetNamespace(namespaceCode: string, observe?: 'body', reportProgress?: boolean): Observable<Namespace>;
    public namespaceGetNamespace(namespaceCode: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Namespace>>;
    public namespaceGetNamespace(namespaceCode: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Namespace>>;
    public namespaceGetNamespace(namespaceCode: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespaceCode === null || namespaceCode === undefined) {
            throw new Error('Required parameter namespaceCode was null or undefined when calling namespaceGetNamespace.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Namespace>(`${this.configuration.basePath}/namespaces/${encodeURIComponent(String(namespaceCode))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getNamespaces
     * Gets a list of namespace keys for all namespaces defined in the system.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public namespaceGetNamespaces(observe?: 'body', reportProgress?: boolean): Observable<NamespaceKeys>;
    public namespaceGetNamespaces(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NamespaceKeys>>;
    public namespaceGetNamespaces(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NamespaceKeys>>;
    public namespaceGetNamespaces(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<NamespaceKeys>(`${this.configuration.basePath}/namespaces`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * searchNamespaces
     * Retrieves all namespaces existing in the system per specified search filters and keys.
     * @param namespaceSearchRequest the namespace search request. The request can only accept a single search filter and a single search key
     * @param fields the field options for the namespace search response. The valid field options are: chargeCode, s3KeyPrefix
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public namespaceSearchNamespaces(namespaceSearchRequest: NamespaceSearchRequest, fields?: string, observe?: 'body', reportProgress?: boolean): Observable<NamespaceSearchResponse>;
    public namespaceSearchNamespaces(namespaceSearchRequest: NamespaceSearchRequest, fields?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NamespaceSearchResponse>>;
    public namespaceSearchNamespaces(namespaceSearchRequest: NamespaceSearchRequest, fields?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NamespaceSearchResponse>>;
    public namespaceSearchNamespaces(namespaceSearchRequest: NamespaceSearchRequest, fields?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespaceSearchRequest === null || namespaceSearchRequest === undefined) {
            throw new Error('Required parameter namespaceSearchRequest was null or undefined when calling namespaceSearchNamespaces.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (fields !== undefined && fields !== null) {
            queryParameters = queryParameters.set('fields', <any>fields);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<NamespaceSearchResponse>(`${this.configuration.basePath}/namespaces/search`,
            namespaceSearchRequest,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateNamespaceDefaultRecordFlag
     * Updates an existing namespace.
     * @param namespaceCode 
     * @param namespaceDefaultRecordFlagUpdateRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public namespaceUpdateNamespaceDefaultRecordFlag(namespaceCode: string, namespaceDefaultRecordFlagUpdateRequest: NamespaceDefaultRecordFlagUpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<Namespace>;
    public namespaceUpdateNamespaceDefaultRecordFlag(namespaceCode: string, namespaceDefaultRecordFlagUpdateRequest: NamespaceDefaultRecordFlagUpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Namespace>>;
    public namespaceUpdateNamespaceDefaultRecordFlag(namespaceCode: string, namespaceDefaultRecordFlagUpdateRequest: NamespaceDefaultRecordFlagUpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Namespace>>;
    public namespaceUpdateNamespaceDefaultRecordFlag(namespaceCode: string, namespaceDefaultRecordFlagUpdateRequest: NamespaceDefaultRecordFlagUpdateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespaceCode === null || namespaceCode === undefined) {
            throw new Error('Required parameter namespaceCode was null or undefined when calling namespaceUpdateNamespaceDefaultRecordFlag.');
        }
        if (namespaceDefaultRecordFlagUpdateRequest === null || namespaceDefaultRecordFlagUpdateRequest === undefined) {
            throw new Error('Required parameter namespaceDefaultRecordFlagUpdateRequest was null or undefined when calling namespaceUpdateNamespaceDefaultRecordFlag.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<Namespace>(`${this.configuration.basePath}/namespaceDefaultRecordFlag/${encodeURIComponent(String(namespaceCode))}`,
            namespaceDefaultRecordFlagUpdateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateNamespaces
     * Updates an existing namespace.
     * @param namespaceCode 
     * @param namespaceUpdateRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public namespaceUpdateNamespaces(namespaceCode: string, namespaceUpdateRequest: NamespaceUpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<Namespace>;
    public namespaceUpdateNamespaces(namespaceCode: string, namespaceUpdateRequest: NamespaceUpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Namespace>>;
    public namespaceUpdateNamespaces(namespaceCode: string, namespaceUpdateRequest: NamespaceUpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Namespace>>;
    public namespaceUpdateNamespaces(namespaceCode: string, namespaceUpdateRequest: NamespaceUpdateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespaceCode === null || namespaceCode === undefined) {
            throw new Error('Required parameter namespaceCode was null or undefined when calling namespaceUpdateNamespaces.');
        }
        if (namespaceUpdateRequest === null || namespaceUpdateRequest === undefined) {
            throw new Error('Required parameter namespaceUpdateRequest was null or undefined when calling namespaceUpdateNamespaces.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<Namespace>(`${this.configuration.basePath}/namespaces/${encodeURIComponent(String(namespaceCode))}`,
            namespaceUpdateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
